<template>
  <div>
    <b-card>
      <notificacao-list
        ref="notificacaoList"
        :carregar="carregar"
        :novo="novo"
        :editar="editar"
        :colunas="colunasListagem"
        :filtros="filtrosPrincipais"
        :info="info"
        :remover="remover"
        :mostrar-remover-lote="false"
      >
        <template slot="icones-acao" slot-scope="{ props }">
          <b-btn
            v-b-tooltip.hover
            title="Editar Notificação"
            variant="none"
            class="btn-none rounded-pill icone-acao"
            @click="editar(props.row)"
          >
            <font-awesome-icon
              :icon="['fas', 'magnifying-glass-chart']"
              size="xl"
              color="var(--primary)"
            />
          </b-btn>
          <b-btn
            v-b-tooltip.hover
            title="Excluir Notificação"
            variant="none"
            class="btn-none rounded-pill icone-acao"
            @click="remover([props.row])"
          >
            <font-awesome-icon
              :icon="['fas', 'arrow-right-arrow-left']"
              size="xl"
              color="var(--primary)"
            />          </b-btn>
        </template>
      </notificacao-list>
    </b-card>
    <notificacao-modal
      ref="notificacaoModal"
      @notification-saved="atualizarLista"
    />
  </div>
</template>
<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import api from '@/app-modulo/comuns/notificacao/shared/services/api'

export default {
  name: 'ListaNotificacao',
  components: {
    FontAwesomeIcon,
    NotificacaoList: () => import('@/shared/components/visualizacao-base/VisualizacaoBase.vue'),
    NotificacaoModal: () => import('@/app-modulo/comuns/notificacao/shared/components/cadastros/Notificacao.vue'),
  },
  data() {
    return {
      colunasListagem: [
        { label: 'Nome da Notificação', field: 'titulo' },
        { label: 'Evento', field: 'eventoNotificacao.nome' },
        {
          label: 'Usuário/Grupo',
          field: 'gruposNotificacao',
          formatFn: value => value.map(grupo => grupo.nome).join(', '),
        },
      ],
      filtrosPrincipais: [],
      info: [],
    }
  },
  methods: {
    atualizarLista() {
      if (this.$refs.notificacaoList) {
        this.$refs.notificacaoList.montarGrid()
      }
    },
    carregar(page, pageSize, filtro) {
      const filtros = {
        filtroPrincipal: filtro,
      }
      return api.getNotificacoesPaginado(page, pageSize, filtros)
    },
    novo() {
      this.$refs.notificacaoModal.abrir()
    },
    editar(value) {
      this.$refs.notificacaoModal.abrir(value.id)
    },
    remover(values) {
      const idList = values.map(item => item.id)
      return api.deleteNotificacoes(idList[0])
        .then(response => response)
        .catch(err => err)
    },
  },
}
</script>
